import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, Navigate } from "react-router-dom";
import GraficoPregunta from "./GraficoPregunta";
import GraficoHorizontal from "./GraficoHorizontal";
import GraficoHorizontal1 from "./GraficoHorizontal1";
import GraficoHorizontal2 from "./GraficoHorizontal2";

import GraficoDonut from "./GraficoDonut";
import GraficoZScore from "./GraficoZScore";
import GraficoZScoreAF from "./GraficoZScoreAF";
import GraficoEC from "./GraficoEC";
import GraficoDonutJuicio from "./GraficoDonutJuicio";
import {
  ExclamationTriangle as Icon_Gem,
  FileEarmarkBarGraph as Icon_File,
  ChevronDown as Icon_ChevronDown,
  ChevronUp as Icon_ChevronUp,
} from "react-bootstrap-icons";

import {
  getEncuestas,
  setFormulario,
  setPreguntaActiva,
  getUsuario,
  setAnswer,
} from "../actions";

import {
  Container,
  Row,
  Col,
  Button,
  ListGroup,
  Table,
  Form,
} from "react-bootstrap";

import { Decimation } from "chart.js";

// Importar archivo de listado
import _resultado1 from "../data/Listado1.json";
import _resultado1_total from "../data/Listado1Total.json";

const Inicio = () => {
  let navigate = useNavigate();
  const dispatch = useDispatch();

  const usuario = useSelector((state) => state.usuario);

  console.log("usuario.Detail 3", usuario);

  const [values, setValues] = useState({});
  const [expandedRows, setExpandedRows] = useState({});

  const _fortalezas = [
    "Optimismo",
    "Esperanza",
    "Autoeficacia",
    "Resiliencia",
    "Prudencia",
    "Autorregulación",
    "Responsabilidad",
    "Vitalidad",
    "Apertura",
  ];

  const _riesgos = [
    "Exceso de Confianza",
    "Pesimismo",
    "Desesperanza",
    "Ineficacia",
    "Fragilidad",
    "Cinismo",
    "Superstición",
    "Influencia Social",
    "Sobre valor de sí mismo",
    "Juicio",
  ];

  const _riesgos_sin_juicio = [
    "Exceso de Confianza",
    "Pesimismo",
    "Desesperanza",
    "Ineficacia",
    "Fragilidad",
    "Cinismo",
    "Superstición",
    "Influencia Social",
    "Sobre valor de sí mismo",
  ];

  const _comb_virtuosa = [
    "Autoeficacia - Fragilidad",
    "Autoeficacia - Desesperanza",
    "Autoeficacia - Pesimismo",
  ];

  const _comb_riesgosa = ["Resiliencia - Fragilidad", "Optimismo - Ineficacia"];

  const _distorsion_motivacional = [
    "Resiliencia - Fragilidad",
    "Esperanza - Desesperanza",
  ];

  const _antifortaleza = [
    "Prudencia",
    "Autorregulación",
    "Responsabilidad",
    "Vitalidad",
    "Apertura",
  ];

  const _alertas = ["Distorsión Motivacional", "Evasión Conductual"];

  const _descripcion = {
    // Fortalezas
    Optimismo:
      "Un operador con alta puntuación en optimismo tenderá a esperar resultados positivos y a mantener una actitud favorable ante los desafíos laborales. Esto facilita la motivación, la perseverancia y la disposición a enfrentar situaciones difíciles con una perspectiva constructiva.",
    Esperanza:
      "Un operador con alta puntuación en esperanza tendrá la capacidad de establecer metas claras, generar rutas para alcanzarlas y mantener la motivación necesaria para persistir ante obstáculos. Esto favorece la planificación y la orientación al logro.",
    Autoeficacia:
      "Un operador con alta puntuación en autoeficacia confiará en su capacidad para organizar y ejecutar las acciones necesarias para alcanzar los logros deseados. Esto implica una adecuada organización de sub-habilidades cognitivas, sociales, emocionales y conductuales.",
    Resiliencia:
      "Un operador con alta puntuación en resiliencia tendrá la capacidad de enfrentar y recuperarse frente a problemas o adversidades. Exhibirá fuerza, resistencia y capacidad de acción ante situaciones difíciles.",
    Prudencia:
      "Da por sentado aquello que ignora, sin reflexionar antes de cada decisión importante, pudiendo sobrestimar sus conocimientos y buscar resolver por cuenta propia",
    Autorregulación:
      "Falta de autoconocimiento  para poder predecir cómo va a responder ante ciertas situaciones, sin desplegar capacidad de modular sus reacciones",
    Responsabilidad:
      "Actúa sin comprender el impacto de sus actos, ni el valor de la vida y los vínculos, como para actuar con seguridad y responsabilidad",
    Vitalidad:
      "Baja fuerza interior y disposición de salud física con la cual enfrento el día a día y lidio con la adversidad, sin lograr sobreponerme",
    Apertura:
      "Incapacidad de cuestionar las propias premisas, y gestionar el sesgo de confirmación, sin lograr gestionar las creencias operantes",

    // Riesgos
    "Exceso de Confianza":
      "Facilita la conducta de no verificación. Implica riesgos altos, que puede tener efectos negativos en el ciclo de gestión de riesgos, específicamente en el control de la ejecución de su trabajo y en la detección de situaciones y condiciones que pueden afectar la ejecución de tareas a realizar. Puede llevar al operador a considerar que domina las habilidades y subestimar peligros, tomar decisiones precipitadas, omitir medidas de seguridad y no prestar la debida atención.",
    Pesimismo:
      "Un operador con puntuación alta en pesimismo tendrá dificultades en resolución activa de problemas y en prestar atención a información relevante para solucionarlo.",
    Desesperanza:
      "Un operador con puntuación alta en desesperanza tendrá bajo nivel de energía dirigida hacia el logro de un objetivo concreto. Puede verse involucrado en accidentes laborales por desconcentración, errores por dificultad para prestar atención.",
    Ineficacia:
      "Un operador con alta puntuación en ineficacia desconfiará de su propia capacidad de organizar y ejecutar las acciones necesarias para alcanzar los logros deseados. En la autoeficacia deben organizarse y desplegarse de manera efectiva sub-habilidades cognitivas, sociales, emocionales y conductuales, las cuales fallan en una persona que se percibe como ineficaz, creyendo que no será capaz de realizar una determinada actividad.",
    Fragilidad:
      "Un operador con alta puntuación en fragilidad le costará enfrentar y recuperarse frente a un problema o adversidad. Exhibirá fuerza, resistencia y acción reducidas.",
    Cinismo:
      "La actitud de cinismo comprende pensamientos y sentimientos de que el cambio sólo ocurre a nivel de discurso y que está mal planeado. Propensión por fingir que se está de acuerdo con las modificaciones necesarias cuando en realidad se obstaculizan cada vez que es posible. Un operador con alta puntuación en cinismo dirá que sí apoya un cambio, pero, está pensando en no hacerlo.",
    Superstición:
      "factor predictor de conductas irracionales, donde la persona nublara su razonamiento en relación con una explicación con un componente mágico o inexplicable",
    "Influencia Social":
      "La influencia de otros puede incidir en el comportamiento de las personas frente al riesgo.   Las creencias actitudes, intenciones y conductas dependen en buena medida de las relaciones que la persona mantenga con otros individuos, grupos o instituciones o de la presencia real, imaginada o implícita de otros.",
    "Sobre valor de sí mismo":
      "Los sesgos que conducen al exceso de confianza generan la sobrestimación de las habilidades propias, del conocimiento propio, de las posibilidades de éxito y del grado de control sobre los sucesos y las situaciones, introduciendo un riesgo.",
    Juicio:
      "Toma decisiones ante escenarios operacionales introduciendo incertidumbre y generando riesgos críticos en la operación, incurriendo en una desviación conductual",

    // Alertas
    "Distorsión Motivacional":
      "Modificación de las respuestas de un postulante para alinearlas con un resultado deseado, no con su autopercepción real, puede deberse a intento deliberado de manipulación, negación de ciertas tendencias o a bajo nivel de comprensión y/o atención de los ítems presentados.",
    "Evasión Conductual":
      "La persona tiende a marcar el centro, es decir no tiene claridad de cómo conducirse o comportarse ante las preguntas, lo que introduce incertidumbre comportamental, generando un riesgo. ",
  };

  const HandleClickReporteDetalle = (props) => {
    console.log("Click Reporte");
    navigate("/reporte_detalle");
  };

  const toggleRowExpansion = (rut) => {
    setExpandedRows((prev) => ({
      ...prev,
      [rut]: !prev[rut],
    }));
  };

  const _listado1 = _resultado1;
  const _totales = _resultado1_total[0];

  // Variables del gráfico cambian segun los fitros seleccionados

  const _total = _listado1.length;

  const _total_apto = _listado1.filter(
    (item) => item.RESULTADO === "APTO",
  ).length;
  const _total_no_apto = _listado1.filter(
    (item) => item.RESULTADO === "NO APTO",
  ).length;

  const _total_riesgos = _listado1.filter(
    (item) => parseInt(item.Total_Riesgo || 0) >= 3,
  ).length;
  const _total_DM = _listado1.filter(
    (item) => parseInt(item.Total_DM || 0) >= 1,
  ).length;
  const _total_AF = _listado1.reduce(
    (sum, item) => sum + parseInt(item.Total_AF || 0),
    0,
  );
  const _total_EC = _listado1.filter(
    (item) => parseInt(item.Total_EC || 0) >= 1,
  ).length;
  const _juicio = _listado1.filter((item) => item.JUI === "R").length;

  // Count items with "R" for each element
  const _total_ECO = _listado1.filter((item) => item.ECO === "R").length;
  const _total_PES = _listado1.filter((item) => item.PES === "R").length;
  const _total_DES = _listado1.filter((item) => item.DES === "R").length;
  const _total_INE = _listado1.filter((item) => item.INE === "R").length;
  const _total_FRA = _listado1.filter((item) => item.FRA === "R").length;
  const _total_CIN = _listado1.filter((item) => item.CIN === "R").length;
  const _total_SUP = _listado1.filter((item) => item.SUP === "R").length;
  const _total_ISO = _listado1.filter((item) => item.ISO === "R").length;
  const _total_SSV = _listado1.filter((item) => item.SSV === "R").length;
  const _total_JUI = _listado1.filter((item) => item.JUI === "R").length;

  // Count items with "D" for each element
  const _total_PRU = _listado1.filter((item) => item.PRU === "D").length;
  const _total_AUT = _listado1.filter((item) => item.AUT === "D").length;
  const _total_RES = _listado1.filter((item) => item.RES === "D").length;
  const _total_VIT = _listado1.filter((item) => item.VIT === "D").length;
  const _total_APE = _listado1.filter((item) => item.APE === "D").length;

  return (
    <Container>
      <Row>
        <Col>
          <Row className="">
            <Col md={3} className="">
              <span className="align-middle">Proceso N° 251204</span>
            </Col>
            <Col md={9} className="">
              <span className="align-middle xz-titulo1 fs-4 fw-bold">
                Cu4400{" "}
              </span>
            </Col>
          </Row>
          <Row>
            <Col md={3}>Fecha</Col>
            <Col md={9}>
              <span className="fs-5 text-secondary text-start">04/12/2025</span>
            </Col>
          </Row>{" "}
          <Row>
            <Col md={3}>Cantidad</Col>
            <Col md={9}>
              {" "}
              <span className="fs-5 text-secondary text-start fw-bold">
                {_listado1.length}
              </span>
            </Col>
          </Row>{" "}
          <Row>
            <Col md={3}>Estado</Col>
            <Col md={9}>
              <span className="text-danger fw-bold fs-5">Concluído</span>
            </Col>
          </Row>{" "}
          <Row>
            <Col md={3}>Ficha Técnica</Col>
            <Col md={9}>
              <a
                href={`${process.env.PUBLIC_URL}/data/Ficha_Tecnica_Cu4400_v1.pdf`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Button
                  variant="outline-primary"
                  size="sm"
                  className="xz-btn-ficha"
                  style={{
                    borderColor: "rgb(84, 47, 25)",
                    color: "rgb(84, 47, 25)",
                  }}
                >
                  <Icon_File size={16} className="me-1" />
                  Ver PDF
                </Button>
              </a>
            </Col>
          </Row>{" "}
        </Col>
      </Row>
      <hr />
      <Row>
        <Col md={3}>
          <h4 className="xz-titulo1">Resultado</h4>
          <Row>
            {/*             <Col md={2} className="text-end">
              Género{" "}
            </Col>
            <Col md={3}>
              <Form.Select size="sm">
                <option>Femenino</option>
                <option>Masculino</option>
                <option>Otra</option>
              </Form.Select>
            </Col>
            <Col md={2} className="text-end">
              Origen{" "}
            </Col>
            <Col md={3}>
              <Form.Select size="sm">
                <option>Inacap</option>
                <option>Esed 1</option>
                <option>Esed 2</option>
                <option>Esed 3</option>
              </Form.Select>
            </Col> */}
          </Row>
          <GraficoDonut datos={[_total_apto, _total_no_apto]} />
        </Col>
        <Col md={4}>
          <h6 className="titulo1" style={{ fontSize: "0.85rem" }}>
            Porcentaje de evaluados con riesgos
          </h6>
          <Row>
            <div style={{ height: "290px", marginBottom: "0px" }}>
              <GraficoHorizontal
                datos={[
                  parseFloat(((_total_ECO / _total) * 100).toFixed(1)),
                  parseFloat(((_total_PES / _total) * 100).toFixed(1)),
                  parseFloat(((_total_DES / _total) * 100).toFixed(1)),
                  parseFloat(((_total_INE / _total) * 100).toFixed(1)),
                  parseFloat(((_total_FRA / _total) * 100).toFixed(1)),
                  parseFloat(((_total_CIN / _total) * 100).toFixed(1)),
                  parseFloat(((_total_SUP / _total) * 100).toFixed(1)),
                  parseFloat(((_total_ISO / _total) * 100).toFixed(1)),
                  parseFloat(((_total_SSV / _total) * 100).toFixed(1)),
                  parseFloat(((_total_JUI / _total) * 100).toFixed(1)),
                ]}
                etiquetas={_riesgos}
                titulo=""
              ></GraficoHorizontal>
            </div>
          </Row>
        </Col>
        <Col md={4}>
          <h6 className="titulo1" style={{ fontSize: "0.85rem" }}>
            Porcentaje de evaluados con antifortalezas
          </h6>

          <Row>
            <div style={{ height: "160px", marginBottom: "20px" }}>
              <GraficoHorizontal1
                datos={[
                  parseFloat(((_total_PRU / _total) * 100).toFixed(1)),
                  parseFloat(((_total_AUT / _total) * 100).toFixed(1)),
                  parseFloat(((_total_RES / _total) * 100).toFixed(1)),
                  parseFloat(((_total_VIT / _total) * 100).toFixed(1)),
                  parseFloat(((_total_APE / _total) * 100).toFixed(1)),
                ]}
                etiquetas={_antifortaleza}
                titulo=""
              ></GraficoHorizontal1>
            </div>{" "}
          </Row>
          <h6 className="titulo1" style={{ fontSize: "0.85rem" }}>
            Porcentaje de evaluados con alertas de conductas críticas de riesgo
          </h6>

          <Row>
            <div style={{ height: "80px", marginBottom: "5px" }}>
              <GraficoHorizontal2
                datos={[
                  parseFloat(((_total_DM / _total) * 100).toFixed(1)),
                  parseFloat(((_total_EC / _total) * 100).toFixed(1)),
                ]}
                etiquetas={_alertas}
                titulo=""
              ></GraficoHorizontal2>
            </div>
          </Row>
        </Col>
      </Row>
      <hr />
      <h4 className="xz-titulo1" style={{ fontSize: "1.20rem" }}>
        Criterios de postulantes NO APTOS
      </h4>
      <Row>
        <Col md={3}></Col>
        <Col>
          <Table size="sm" style={{ tableLayout: "fixed" }}>
            <thead>
              <tr className="xz-tb-titulo1">
                <th className="w-50">CRITERIO</th>
                <th className="w-35">INDICADOR</th>
                <th className="w-15">BAREMO</th>
              </tr>
            </thead>
            <tbody>
              <tr style={{ height: "60px" }}>
                <td className="xz-tb-texto1">Riesgo</td>
                <td className="xz-tb-texto2">
                  Presencia de 3 o más Riesgos (del total de 10 riesgos)
                </td>
                <td className="xz-tb-texto3">
                  La media aritmética del grupo más 0,7 desviaciones estándar.
                  <br />
                  Área bajo la curva 0,7580
                </td>
              </tr>
              <tr style={{ height: "60px" }}>
                <td className="xz-tb-texto1">Anti Fortaleza</td>
                <td className="xz-tb-texto2">
                  Presencia de 3 o más Anti Fortalezas (del total de 5
                  AntiFortalezas)
                </td>
                <td className="xz-tb-texto3">
                  La media aritmética del grupo menos 0,7 desviaciones estándar.
                  <br />
                  Área bajo la curva 0,2419
                </td>
              </tr>
              <tr style={{ height: "60px" }}>
                <td className="xz-tb-texto1">
                  Alerta de Conducta Crítica de Riesgo (CCR) en Prueba
                  Situacional
                </td>
                <td className="xz-tb-texto2">
                  7 o más respuestas incorrectas o, 2 o más respuestas CCR
                </td>
                <td className="xz-tb-texto3"></td>
              </tr>

              <tr style={{ height: "60px" }}>
                <td className="xz-tb-texto1">Evasión Conductual </td>
                <td className="xz-tb-texto2">
                  Más de 50% de evasión en preguntas tipo Likert 5
                </td>
                <td></td>
              </tr>
              <tr style={{ height: "60px" }}>
                <td className="xz-tb-texto1">Distorsión motivacional </td>
                <td className="xz-tb-texto2">
                  Presente en 100% de los instrumentos donde se evalúa (4)
                </td>
                <td></td>
              </tr>
            </tbody>
          </Table>
        </Col>
      </Row>
      <hr />

      {/*       <h4 className="mt-4">
        Alertas Conductas Críticas de Riesgo
        <span className="titulo2"></span>
      </h4>
      <Row className="xz-row-2">
        <Col md={3} className="titulo3">
          <span className="align-middle">Alerta de Juicio Operacional</span>
        </Col>
        <Col md={1} className="titulo1">
          <span className="align-middle">5 de 24</span>
        </Col>
        <Col md={8} className="fw-bold">
          <p>
            Identifica la cantidad de casos donde se detectaron juicios
            riesgosos. La persona toma decisiones ante escenarios operacionales,
            introduciendo incertidumbre y generando riesgos críticos en la
            operación.{" "}
          </p>
          <p>
            Esta dimensión permite controlar la generación de riesgos a partir
            de evitar que personas que declaran que incurrirían en una
            desviación conductual ingresen a operar a la compañía.
          </p>
        </Col>
      </Row>
      <br />
      <Row className="xz-row-2">
        <Col md={3} className="titulo3 ">
          <span className="align-middle">Alerta de Evasión Conductual</span>
        </Col>
        <Col md={1} className="titulo1">
          <span className="align-middle">4 de 24</span>
        </Col>
        <Col md={8} className="fw-bold">
          Identifica la cantidad de casos donde se detectaron personas que
          evitan identificarse con las alternativas. La persona tiende a marcar
          el centro, es decir no tiene claridad de cómo conducirse o comportarse
          ante las preguntas, lo que introduce incertidumbre comportamental,
          generando un riesgo.
        </Col>
      </Row> */}
      <br />
      <br />
      {/*
      <h4 className="mt-4">
        Riesgos<span className="titulo2"></span>
      </h4>

      <h4 className="mt-4">
        Fortalezas<span className="titulo2"></span>
      </h4>

      <h4 className="mt-4">
        Combinaciones Virtuosas y Riesgosas<span className="titulo2"></span>
      </h4>
      */}
      <hr />
      <div className="d-flex justify-content-between align-items-center mb-2">
        <h4 className="xz-titulo1 mb-0" style={{ fontSize: "1.20rem" }}>
          Resumen por Evaluado
        </h4>
        <Button
          variant="outline-secondary"
          size="sm"
          style={{ fontSize: "0.7rem", padding: "2px 8px" }}
          onClick={() => setExpandedRows({})}
        >
          Colapsar todo
        </Button>
      </div>
      <Row>
        <Col>
          <div className="xz-table-scroll-container">
            <Table className="xz-table-esg">
              <thead>
                <tr>
                  <th style={{ width: "40px" }}>N°</th>
                  <th style={{ width: "20%" }}>Nombre</th>
                  <th
                    className="d-none d-md-table-cell"
                    style={{ width: "12%" }}
                  >
                    RUT
                  </th>
                  <th>Resultado</th>
                  <th className="d-none d-md-table-cell">Riesgos</th>
                  <th className="d-none d-md-table-cell">Juicio</th>
                  <th className="d-none d-md-table-cell">Anti Fortaleza</th>
                  <th className="d-none d-md-table-cell">Dist. Motivacional</th>
                  <th className="d-none d-md-table-cell">Evasión Conductual</th>
                  <th className="d-none d-lg-table-cell">Criterios</th>
                  <th style={{ width: "30px" }}></th>
                </tr>
              </thead>
              <tbody>
                {_listado1
                  .sort((a, b) => {
                    const resultadoCompare = a.RESULTADO.localeCompare(
                      b.RESULTADO,
                    );
                    if (resultadoCompare !== 0) return resultadoCompare;
                    return a.nombre.localeCompare(b.nombre);
                  })
                  .map((item, index) => {
                    const isExpanded = expandedRows[`tbl_${item.rut}`];
                    return (
                      <React.Fragment key={item.rut}>
                        <tr
                          className="xz-row-clickable"
                          onClick={() =>
                            setExpandedRows((prev) => ({
                              ...prev,
                              [`tbl_${item.rut}`]: !prev[`tbl_${item.rut}`],
                            }))
                          }
                        >
                          <td
                            style={{
                              backgroundColor:
                                item.RESULTADO === "APTO"
                                  ? "rgb(17,135,171)"
                                  : "#c0504d",
                            }}
                          >
                            {index + 1}
                          </td>
                          <td style={{ fontWeight: 600, color: "#333" }}>
                            {item.nombre}
                          </td>
                          <td className="d-none d-md-table-cell">{item.rut}</td>
                          <td
                            style={{
                              fontWeight: 700,
                              color:
                                item.RESULTADO === "APTO"
                                  ? "#2e7d32"
                                  : "#c0504d",
                            }}
                          >
                            {item.RESULTADO}
                          </td>
                          <td className="text-center d-none d-md-table-cell">
                            {item.Total_Riesgo !== "0" ? item.Total_Riesgo : ""}
                          </td>
                          <td className="text-center d-none d-md-table-cell">
                            {item.JUI === "R" ? "R" : ""}
                          </td>
                          <td className="text-center d-none d-md-table-cell">
                            {item.Total_AF !== "0" ? item.Total_AF : ""}
                          </td>
                          <td className="text-center d-none d-md-table-cell">
                            {item.Total_DM !== "0" ? item.Total_DM : ""}
                          </td>
                          <td className="text-center d-none d-md-table-cell">
                            {item.Total_EC !== "0" ? item.Total_EC : ""}
                          </td>
                          <td
                            className="d-none d-lg-table-cell"
                            style={{ fontSize: "0.78rem" }}
                          >
                            {item.OBSERVACIONES}
                          </td>
                          <td className="text-center">
                            {isExpanded ? (
                              <Icon_ChevronUp size={14} />
                            ) : (
                              <Icon_ChevronDown size={14} />
                            )}
                          </td>
                        </tr>
                        {isExpanded && (
                          <tr className="xz-row-detail">
                            <td colSpan={11}>
                              <div
                                style={{
                                  width: "100%",
                                  maxWidth: "100%",
                                  overflow: "hidden",
                                }}
                              >
                                <Row>
                                  <Col xs={12} md={5}>
                                    <Table
                                      size="sm"
                                      bordered
                                      style={{ marginBottom: 0 }}
                                    >
                                      <tbody>
                                        <tr style={{ lineHeight: "1.2" }}>
                                          <td className="fw-bold py-1">RUT</td>
                                          <td className="py-1">{item.rut}</td>
                                        </tr>
                                        <tr style={{ lineHeight: "1.2" }}>
                                          <td className="fw-bold py-1">
                                            Resultado
                                          </td>
                                          <td className="py-1">
                                            {item.RESULTADO}
                                          </td>
                                        </tr>
                                        <tr style={{ lineHeight: "1.2" }}>
                                          <td className="fw-bold py-1">
                                            Total Riesgos
                                          </td>
                                          <td className="py-1">
                                            {item.Total_Riesgo}
                                          </td>
                                        </tr>
                                        <tr style={{ lineHeight: "1.2" }}>
                                          <td className="fw-bold py-1">
                                            Juicio (JUI)
                                          </td>
                                          <td className="py-1">
                                            {item.JUI || "Sin Riesgo"}
                                          </td>
                                        </tr>
                                        <tr style={{ lineHeight: "1.2" }}>
                                          <td className="fw-bold py-1">
                                            Anti Fortaleza
                                          </td>
                                          <td className="py-1">
                                            {item.Total_AF}
                                          </td>
                                        </tr>
                                        <tr style={{ lineHeight: "1.2" }}>
                                          <td className="fw-bold py-1">
                                            Distorsión Motivacional
                                          </td>
                                          <td className="py-1">
                                            {item.Total_DM}
                                          </td>
                                        </tr>
                                        <tr style={{ lineHeight: "1.2" }}>
                                          <td className="fw-bold py-1">
                                            Evasión Conductual
                                          </td>
                                          <td className="py-1">
                                            {item.Total_EC}
                                          </td>
                                        </tr>
                                        <tr style={{ lineHeight: "1.2" }}>
                                          <td className="fw-bold py-1">
                                            Detalle
                                          </td>
                                          <td className="titulo1 py-1">
                                            {item.OBSERVACIONES}
                                          </td>
                                        </tr>
                                      </tbody>
                                    </Table>
                                  </Col>
                                  <Col xs={12} md={7}>
                                    <div
                                      className="rounded p-3"
                                      style={{
                                        maxHeight: "350px",
                                        overflowY: "auto",
                                        fontSize: "0.73rem",
                                      }}
                                    >
                                      {(() => {
                                        const hallazgos = [];

                                        // Riesgos (Z >= 0.7 SD → marcados con "R")
                                        const riesgoMap = [
                                          {
                                            campo: "ECO",
                                            nombre: "Exceso de Confianza",
                                          },
                                          { campo: "PES", nombre: "Pesimismo" },
                                          {
                                            campo: "DES",
                                            nombre: "Desesperanza",
                                          },
                                          {
                                            campo: "INE",
                                            nombre: "Ineficacia",
                                          },
                                          {
                                            campo: "FRA",
                                            nombre: "Fragilidad",
                                          },
                                          { campo: "CIN", nombre: "Cinismo" },
                                          {
                                            campo: "SUP",
                                            nombre: "Superstición",
                                          },
                                          {
                                            campo: "ISO",
                                            nombre: "Influencia Social",
                                          },
                                          {
                                            campo: "SSV",
                                            nombre: "Sobre valor de sí mismo",
                                          },
                                        ];
                                        riesgoMap.forEach(
                                          ({ campo, nombre }) => {
                                            if (item[campo] === "R") {
                                              hallazgos.push({
                                                tipo: "Riesgo",
                                                nombre,
                                                descripcion:
                                                  _descripcion[nombre],
                                              });
                                            }
                                          },
                                        );

                                        // Juicio
                                        if (item.JUI === "R") {
                                          hallazgos.push({
                                            tipo: "Riesgo",
                                            nombre: "Juicio",
                                            descripcion: _descripcion["Juicio"],
                                          });
                                        }

                                        // Anti Fortalezas (Z < -0.7 SD → marcadas con "D")
                                        const afMap = [
                                          { campo: "PRU", nombre: "Prudencia" },
                                          {
                                            campo: "AUT",
                                            nombre: "Autorregulación",
                                          },
                                          {
                                            campo: "RES",
                                            nombre: "Responsabilidad",
                                          },
                                          { campo: "VIT", nombre: "Vitalidad" },
                                          { campo: "APE", nombre: "Apertura" },
                                        ];
                                        afMap.forEach(({ campo, nombre }) => {
                                          if (item[campo] === "D") {
                                            hallazgos.push({
                                              tipo: "Anti Fortaleza",
                                              nombre,
                                              descripcion: _descripcion[nombre],
                                            });
                                          }
                                        });

                                        // Distorsión Motivacional
                                        if (parseInt(item.Total_DM || 0) > 0) {
                                          hallazgos.push({
                                            tipo: "Alerta",
                                            nombre: "Distorsión Motivacional",
                                            descripcion:
                                              _descripcion[
                                                "Distorsión Motivacional"
                                              ],
                                          });
                                        }

                                        // Evasión Conductual
                                        if (parseInt(item.Total_EC || 0) > 0) {
                                          hallazgos.push({
                                            tipo: "Alerta",
                                            nombre: "Evasión Conductual",
                                            descripcion:
                                              _descripcion[
                                                "Evasión Conductual"
                                              ],
                                          });
                                        }

                                        if (hallazgos.length === 0) {
                                          return (
                                            <span className="text-muted">
                                              Sin observaciones relevantes.
                                            </span>
                                          );
                                        }

                                        return hallazgos.map((h, idx) => (
                                          <div
                                            key={idx}
                                            className={
                                              idx > 0
                                                ? "mt-2 pt-2 border-top"
                                                : ""
                                            }
                                          >
                                            <span
                                              className="badge me-2"
                                              style={{
                                                backgroundColor:
                                                  h.tipo === "Riesgo"
                                                    ? "#c0504d"
                                                    : h.tipo ===
                                                        "Anti Fortaleza"
                                                      ? "#e6a020"
                                                      : "#6c757d",
                                                fontSize: "0.72rem",
                                              }}
                                            >
                                              {h.tipo}
                                            </span>
                                            <strong>{h.nombre}</strong>
                                            <p
                                              className="mb-0 mt-1"
                                              style={{ color: "#555" }}
                                            >
                                              {h.descripcion}
                                            </p>
                                          </div>
                                        ));
                                      })()}
                                    </div>
                                  </Col>
                                </Row>
                                <Row className="mt-3">
                                  <Col xs={12} md={6}>
                                    <h6
                                      className="fw-bold"
                                      style={{
                                        fontSize: "0.85rem",
                                        color: "#016c99",
                                      }}
                                    >
                                      Riesgos: Z-Score vs Media del Grupo
                                    </h6>
                                    <div style={{ height: "320px" }}>
                                      <GraficoZScore
                                        item={item}
                                        totales={_totales}
                                      />
                                    </div>
                                  </Col>
                                  <Col xs={12} md={6}>
                                    <h6
                                      className="fw-bold"
                                      style={{
                                        fontSize: "0.85rem",
                                        color: "#016c99",
                                      }}
                                    >
                                      Antifortalezas: Z-Score vs Media del Grupo
                                    </h6>
                                    <div style={{ height: "320px" }}>
                                      <GraficoZScoreAF
                                        item={item}
                                        totales={_totales}
                                      />
                                    </div>
                                  </Col>
                                </Row>
                                <Row className="mt-3">
                                  <Col xs={12} md={8}>
                                    <h6
                                      className="fw-bold"
                                      style={{
                                        fontSize: "0.85rem",
                                        color: "#016c99",
                                      }}
                                    >
                                      Evasión Conductual (%)
                                    </h6>
                                    <div style={{ height: "250px" }}>
                                      <GraficoEC item={item} />
                                    </div>
                                  </Col>
                                  <Col xs={12} md={4}>
                                    <h6
                                      className="fw-bold"
                                      style={{
                                        fontSize: "0.85rem",
                                        color: "#016c99",
                                      }}
                                    >
                                      Riesgo de Juicio
                                    </h6>
                                    <div style={{ height: "250px" }}>
                                      <GraficoDonutJuicio item={item} />
                                    </div>
                                  </Col>
                                </Row>
                              </div>
                            </td>
                          </tr>
                        )}
                      </React.Fragment>
                    );
                  })}
              </tbody>
            </Table>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default Inicio;
